/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unsafe-storage */
import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'SafeStorage'

import SafeStorage from 'SafeStorage';
import Raven from 'raven-js';
import { changeEnrollmentOnboardingSettings } from './api/onboardingSettings';
import { changeEnrollmentUserAttributes } from './api/userAttributes';
const USER_ATTRIBUTES_URI = `users/v1/app/attributes`;
const ONBOARDING_ENROLLED_LOCAL_STORAGE_KEY = 'GrowthOnboarding:IsEnrolledInGettingStarted';
export function getGSEnrollmentUserAttributeKey(portalId = PortalIdParser.get()) {
  return `GrowthOnboarding:ShouldSeeNewOnboarding:${portalId}`;
}
export function changeEnrollment(isEnrolled, userId, portalId, options = {}) {
  // dual writing to Onboarding Settings and UserAttributes API
  return Promise.allSettled([changeEnrollmentOnboardingSettings(isEnrolled, options), changeEnrollmentUserAttributes(isEnrolled, userId, portalId, options)]).then(results => {
    results.forEach(result => {
      if (result.status === 'rejected') {
        Raven.captureException(result.reason);
      }
    });
    return results;
  });
}
export function unenrollInGettingStarted(userId, portalId) {
  return changeEnrollment(false, userId, portalId);
}
export function enrollInGettingStarted(userId, portalId, options) {
  return changeEnrollment(true, userId, portalId, options);
}
export function enrollInUserGuide(options) {
  return changeEnrollmentOnboardingSettings(true, options);
}
export function unenrollInUserGuide(options) {
  return changeEnrollmentOnboardingSettings(false, options);
}
export function unenrollInGettingStartedLocally() {
  SafeStorage.removeItem(ONBOARDING_ENROLLED_LOCAL_STORAGE_KEY);
}
export function enrollInGettingStartedLocally() {
  SafeStorage.setItem(ONBOARDING_ENROLLED_LOCAL_STORAGE_KEY, Date.now());
}
export function isEnrollParamPresent() {
  return window.location.search.indexOf('enroll=true') >= 0;
}
export function isUserEnrolledInGettingStarted(portalId) {
  return http.get(USER_ATTRIBUTES_URI, {
    query: {
      key: getGSEnrollmentUserAttributeKey(portalId)
    }
  }).then(({
    attributes
  }) => {
    if (!attributes || attributes.length === 0) {
      return false;
    }

    const [enrollmentAttribute] = attributes;
    return enrollmentAttribute.value === 'true';
  });
}